// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__FuiIZ","loading-lottie":"style_loading-lottie__mFNS6"};